<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0" :adelanteVisible="mostrarAdelante" @update:currentText="currentText = $event"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page animated fadeIn" v-if="diagNum == 0">
          <v-flex xs12 sm7 md7>
          <!-- dialogo hombre -->
            <v-layout class="animated fadeInRight dura-3" row mt-2>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>{{diagHombre[diagNum]}}</p>
              </v-flex>
              <div class="imagen-personaje-hombre"></div>
            </v-layout>
          <!-- dialogo ella -->
            <v-layout class="animated fadeInLeft dura-4" row mt-2>
              <div class="imagen-personaje-mujer"></div>
              <v-flex xs11 md11 class="cont-dialogo">
                <!-- dropables -->
                <div v-for="(dropItem, index) in dropList" :key="'item'+index" class="item-drop">
                  <draggable v-model="dropList[index]" @change="change($event, index)" :options="{group:'items'}">
                  <p v-for="element in dropList[index]" :key="element"> <span v-html="element"></span></p>
                  </draggable>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page animated fadeIn" v-if="diagNum == 1">
          <v-flex xs12 sm7 md7>
          <!-- dialogo hombre -->
            <v-layout class="animated fadeInRight dura-1" row mt-2>
              <v-flex xs11 md11 class="cont-dialogo">
                <p>{{diagHombre[diagNum]}}</p>
              </v-flex>
              <div class="imagen-personaje-hombre"></div>
            </v-layout>
          <!-- dialogo ella -->
            <v-layout class="animated fadeInLeft dura-2" row mt-2>
              <div class="imagen-personaje-mujer"></div>
              <v-flex xs11 md11 class="cont-dialogo">
                <!-- dropables -->
                <div v-for="(dropItem, index) in dropList" :key="'item'+index" class="item-drop">
                  <draggable v-model="dropList[index]" @change="change($event, index)" :options="{group:'items'}">
                  <p v-for="element in dropList[index]" :key="element"> <span v-html="element"></span></p>
                  </draggable>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- draggables -->
        <v-layout wrap row justify-center align-center text-xs-center pb-5 class="cont_page animated fadeIn" v-show="ocultarDrag">
          <v-flex xs10 mt-2 class="animated fadeInUp dura-3">
            <draggable v-model="dragList" @start="saveEl" class="drag-container" :options="{group:'items'}">
                  <div v-for="element in dragList" :key="element">
                    <div class="btn-blue-dark btn-drag hvr" >
                      <span v-html="element"></span>
                    </div>
                  </div>
            </draggable>
          </v-flex>
        </v-layout>
    <modal-resultado-app v-model="modalResultado" :nameResult="modalResult" 
    @bienAvanzar="bienAction()" @malAvanzar="malAction()">
    </modal-resultado-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'
export default {
  mixins: [nextConditions],
  components: {
			draggable
  },
  data() {
    return {
      dialogos: [
        'O Paulo quer conhecer a Karin. Selecione as respostas da Karin.',
        'Ótimo! Agora, clique em avançar.'
      ],
      diagHombre:[
        'Karin, você é alemã?',
        'Desculpe, você fala outra língua?'
      ],
      model: null,
      currentText:0,
      dragList:[
        'Não, não sou alemã, sou brasileira.',
        'Não.',
        'Sim, sou alemã.',
        'Sim, eu falo alemão.',
        'Sim.'
      ],
      correctas:[
        'Não, não sou alemã, sou brasileira.',
        'Sim, eu falo alemão.',
      ],
      dropList:Array(1).fill([]),
      lastElement: "",
      modalResultado:false,
      modalResult:'mal',
      diagNum:0,
      mostrarAdelante:false,
      ocultarDrag:true
    }
  },
  mounted(){
    this.dragList.sort(function() {
      return 0.6 - Math.random()
    });
  },
  watch: {
    currentText(){
      this.$store.commit('nextShow', true);
    }
  },
  methods: {
    saveEl(ev) {
      console.log('start ' + ev.item.innerHTML)
      this.lastElement = ev.item.innerHTML
    },
    change(ev, slotNum) {
      var posCorrectas = this.diagNum
      console.log('this.dropList '+ this.dropList)
      console.log()
      if(this.dropList[0] == this.correctas[posCorrectas]){
        this.modalResultado = true
        this.modalResult = 'bien'
      }else {
        this.modalResultado = true
        this.modalResult = 'mal'
        this.dragList.push(ev.added.element)
      }
    },
    bienAction(){      
      if(this.diagNum == 0){
        setTimeout(() => {
        this.diagNum = 1
        this.dropList = Array(1).fill([])
        this.dragList.sort(function() {
        return 0.6 - Math.random()
        });
        }, 500);
      }else{
        this.mostrarAdelante = true
        this.ocultarDrag = false
      }
    },
    malAction(){
      this.dropList = Array(1).fill([])
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.cont-drop{
  margin: 10px 30px;
  padding: 10px;
  p{
    margin: 0;
    padding: 0;
    color:$ibra-gray;
    font-family: Poppins-Regular;
    font-size: 12px;
  }
}
.drop-correcto{
  background: $ibra-green;
}
.drop-incorrecto{
  background: $ibra-orange;
}

.btn-drag{
  width: 180px;
  margin: 0 auto;
  padding: 3px;
  margin-top: 2px;

}
.cont-btn-nextprev{
  position: relative;
  width: 40%;
  top: 100%;
  margin: 0 auto;
  padding: 12px;
  margin-top: 8px;
  .btn-slide-next{
    right: 0;
    position: absolute;
  }
  .btn-slide-prev{
    left: 0;
    position: absolute;
  }
}
.cont-dialogo{
  background: #81C7FD;
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  p{
    margin: 0;
    padding: 0;
    font-family:Poppins-Regular;
    font-size: 13px;

  }
}
.imagen-personaje-hombre{
  background: url('../../assets/unidad1/slide-6/slide-6-1.jpg')no-repeat 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
}
.imagen-personaje-mujer{
  background: url('../../assets/unidad1/slide-6/slide-6-2.jpg')no-repeat 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
}
.item-drop{
  padding: 4px;
  width: 80%;
}
</style>
